import * as types from '../mutation-types';
import config from '@/config';
import { loadDataForSnapshot } from '@/utils/loading';
import Vue from 'vue';


const state = {
  places: {},
};

const mutations = {
  [types.SET_PLACES]: (state, places) => {
    state.places = places;
  },
  [types.UPDATE_PLACES]: (state, { places }) => {
    places.forEach((place) => {
      const oldPlace = state.places[place.id];
      if (oldPlace) {
        state.places[place.id] = { ...oldPlace, ...place };
      }
    });
  },
};

const getters = {
  getPlaces: state => Object.values(state.places),
  getPlaceById: state => placeId => state.places[placeId],
  getPlaceName: (state, getters, rootState, rootGetters) => (placeId) => {
    const place = getters.getPlaceById(placeId);
    return rootGetters['user/isUserInstaller'] ? place.name : place.user_name || place.name;
  },
};

const actions = {
  async loadPlaces({ commit, rootState }) {
    return loadDataForSnapshot(commit, rootState, types.SET_PLACES, config.ICOOL.API.PLACES_PATH);
  },
  updatePlaces({ commit, dispatch }, { places }) {
    commit(types.UPDATE_PLACES, { places });
  },
  SOCKET_PLACE_UPDATED({ commit, getters }, msg) {
    const data = JSON.parse(msg);
    Vue.$log.debug(data);
    commit(types.UPDATE_PLACES, { places: [data] });
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
